import React from "react";
import Hero from "./Hero";
import Brokerage2 from "./Brokerage2";
import Charges from "./Charges";

function PricingPageEquity() {
    return ( 
        <>
      <Hero />
      <Brokerage2/>
      <Charges/>
    </>
     );
}

export default PricingPageEquity;